var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7791 5.89151C13.7791 4.61673 13.2727 3.39417 12.3713 2.49277C11.4699 1.59136 10.2473 1.08496 8.97252 1.08496C7.69774 1.08496 6.47518 1.59136 5.57378 2.49277C4.67237 3.39417 4.16597 4.61673 4.16597 5.89151C4.16597 11.4991 1.7627 13.1013 1.7627 13.1013H16.1823C16.1823 13.1013 13.7791 11.4991 13.7791 5.89151Z",
    stroke: "#8F90A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3587 15.2373C10.2178 15.4801 10.0157 15.6816 9.77247 15.8217C9.52925 15.9618 9.25349 16.0356 8.9728 16.0356C8.69212 16.0356 8.41636 15.9618 8.17313 15.8217C7.92991 15.6816 7.72775 15.4801 7.58691 15.2373",
    stroke: "#8F90A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/Subscribe.42afbcc43cca4f59461ccb61a3f63bbc.svg";
export { ForwardRef as ReactComponent };